import Audio from '../../shared/audio';
import {Segment} from 'semantic-ui-react';

function PackageError() {
  return (
    <Segment>
      <p>
        داوطلب گرامی پرداخت شما با موفقیت انجام شد،
        به زودی تکالیف شما فعال شده و مشاور شما انتخاب خواهد شد.
      </p>
      <p>
        لطفا شماره تلفن 09037653789 را با عنوان "ادمین خصوصی گروه مدمشاور" بین مخاطبین گوشی خود ذخیره کنید
        و یک پیام حاوی نام و مشخصات خود در تلگرام به این شماره بفرستید
        تا امکان اضافه کردن شما به گروه تلگرامی وجود داشته باشد.
      </p>
      <p>
        تا زمان اضافه شدن شما به گروه و فعال شدن برنامه، لطفا توضیحات صوتی زیر را گوش کنید.
        در این ویس توضیحات اجرای برنامه، توسط دکتر شریفی داده شده است.
      </p>
      <p>
          انتخاب مشاورین بر اساس ظرفیت اعلام شده توسط مشاورین انجام خواهد شد.
          در صورتی که ترجیح می دهید فرد خاصی مشاور شما باشد،
          پس از ایجاد گروه تلگرام برای شما می توانید
          درخواست خود را با ادمین خصوصی مدمشاور مطرح کنید.
      </p>

      <Audio
        src='/voices/private consult.mp3'
        caption='فایل صوتی توضیحات دکتر شریفی:'
      />

      <p className='text-center'>
        <a
          href='https://t.me/medmoshaver'
          rel='noopener noreferrer'
          target='_blank'
        >
          آدرس گروه مد مشاور در تلگرام
        </a>
      </p>
      <p className='text-center'>
        <a
          href='https://t.me/medmoshaver_admin'
          rel='noopener noreferrer'
          target='_blank'
        >
          آدرس ادمین گروه مد مشاور در تلگرام
        </a>
      </p>
    </Segment>
  );
}

export default PackageError;
